import { FileText } from "lucide-react";
import { Badge } from "@/components/ui/Badge";
import {
  PROTOCOL_STATUS_COLORS,
  PROTOCOL_STATUS_LABELS,
  type HandoverProtocol,
} from "../types";
import { formatDate } from "../utils";

interface Props {
  protocol: HandoverProtocol;
  showEmployee?: boolean;
  children?: React.ReactNode;
}

export function ProtocolCard({ protocol, showEmployee, children }: Props) {
  return (
    <div className="border border-[var(--color-border)] p-3 space-y-2 bg-[var(--color-bg-surface)]">
      <div className="flex items-start justify-between gap-2">
        <div>
          <div className="flex items-center gap-2">
            <span className="text-xs font-mono text-[var(--color-text-muted)]">#{protocol.number}</span>
            {showEmployee && (
              <span className="text-sm font-medium text-[var(--color-text-primary)]">
                {protocol.employee_name ?? "—"}
              </span>
            )}
            <Badge color={PROTOCOL_STATUS_COLORS[protocol.status]}>
              {PROTOCOL_STATUS_LABELS[protocol.status]}
            </Badge>
          </div>
          <div className="text-xs text-[var(--color-text-muted)] mt-0.5">
            Złożono: {formatDate(protocol.created_at)}
          </div>
        </div>
        {protocol.signed_document_detail?.url && (
          <a
            href={protocol.signed_document_detail.url}
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center gap-1 text-xs text-blue-600 hover:underline shrink-0"
          >
            <FileText size={13} /> Protokół
          </a>
        )}
      </div>

      <div className="flex flex-wrap gap-1">
        {protocol.items_detail.map((it) => (
          <span
            key={it.id}
            className="text-xs px-2 py-0.5 bg-[var(--color-bg-elevated)] border border-[var(--color-border)]"
          >
            {it.name}
          </span>
        ))}
      </div>

      {protocol.note && (
        <p className="text-xs text-[var(--color-text-secondary)]">Uwagi: {protocol.note}</p>
      )}
      {protocol.review_comment && (
        <p className="text-xs text-[var(--color-text-secondary)]">
          Komentarz: {protocol.review_comment}
        </p>
      )}
      {protocol.reviewed_by_name && (
        <p className="text-xs text-[var(--color-text-muted)]">
          Rozpatrzył: {protocol.reviewed_by_name} · {formatDate(protocol.reviewed_at)}
        </p>
      )}

      {children}
    </div>
  );
}
